import {IActionBase} from "./IActionBase";

import React, {Component} from "react";

import {store} from "../../redux/storeConfig/store";
import {utils_ui} from "../utils/utils_ui";
import {ActionsManager} from "./actionsManager";

export class navigateToPage extends Component implements IActionBase {

    actionCode = "navigateToPage";
    actionName = "navigateToPage";

    Execute = (prmActionParameters:any, prmActionsManager?:ActionsManager, prmElementObj?:any, prmData?:any)=> {
            // if (!!prmElementObj) {
            //     runtimeUtils.parseRelatedParamsForElement(prmElementObj);
            //     doesn't work -need to implement rootScopeObj for this.
            // }
            // alert('navigateToPage')
            //TODO: handle data
            // if (!!prmData) {
            //     currActionTypeObj.internals.parseRelatedParamsFromData(prmActionParameters, prmData);
            // }
            let currProjectID = store.getState().store_ProjectData.projectID
            let rowParamsStr = "";

            if (!!prmActionParameters && !!prmActionParameters.Parameters){
                let lstParams:any = prmActionParameters?.Parameters?.filter((prmItem:any) => {return prmItem?.Key != 'blank'})
                //                                 .map((prmItem:any, index:number) => {
                //         rowParamsStr += `${prmItem.Key}=${utils_ui.GetParamValue(prmItem.Value)}&`;
                // });

                let lstNavigationParam:any = []
                for (const currParam of lstParams) {
                    if (!!currParam.Key && !!currParam.Value) {
                        let currValue = ""
                        let currParamValueStr = currParam.Value.replaceAll('[','').replaceAll(']','')
                        if (!!prmData && prmData.hasOwnProperty(currParamValueStr)) {
                            currValue = prmData[currParamValueStr]
                        }
                        else {
                            currValue = utils_ui.GetParamValue(currParam.Value)
                        }

                        lstNavigationParam.push(`${currParam.Key}=${currValue}`)
                    }
                }

                rowParamsStr = lstNavigationParam.join('&')
            }

            let isBlank = (prmActionParameters?.Parameters?.filter((prmItem:any) => {return prmItem?.Key == 'blank'}).length > 0)
            let navUrl = `/applyoo/${currProjectID}/${prmActionParameters?.PageCode}`

            if (!!rowParamsStr){
                //navUrl = navUrl + `?${rowParamsStr.substr(0,rowParamsStr.length - 1)}`
                navUrl = navUrl + `?${rowParamsStr}`
            }

            if (isBlank) {
                window.open(navUrl, "_blank");
            }
            else {
                store.dispatch({type:'NAVIGATE', currentLocation: navUrl});//the best way to use our reducers inside class component - dispatch and getState are the functions that we need-getState for data and dispatch for sending data
            }

        }

}
